var r = Array.isArray, a = r;
export {
  a as i
};
//# sourceMappingURL=isArray.CAJdVVdL.js.map
